import { i18n } from '@/i18n'

export function messageForErrorCode(code: unknown): string | null {
  if (typeof code !== 'string') {
    return null
  }

  const key = `errors.${code}`

  return i18n.global.te(key) ? i18n.global.t(key) : null
}
